import { render } from "./bank-card.html?vue&type=template&id=4122c2b2&scoped=true&ts=true&external"
import script from "./bank-card.ts?vue&type=script&lang=ts&external"
export * from "./bank-card.ts?vue&type=script&lang=ts&external"

import "./bank-card.scss?vue&type=style&index=0&id=4122c2b2&scoped=true&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4122c2b2"]])

export default __exports__